module.exports = "/_next/static/images/concerts-ce58b8e6a158dd116eba80822fc13610.jpg";